import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import AuthLoadingBoundary from './AuthLoadingBoundary'

const ProtectedRoute = ({ 
  children, 
  requireAuth = true, 
  requireSuperAdmin = false,
  redirectTo = '/login' 
}) => {
  const { user, loading, authInitialized, isSuperAdmin } = useAuth()
  const location = useLocation()

  console.log('🛡️ ProtectedRoute check:', {
    requireAuth,
    requireSuperAdmin,
    user: !!user,
    loading,
    authInitialized,
    isSuperAdmin: isSuperAdmin(),
    pathname: location.pathname
  })

  // Show loading boundary while auth is initializing
  if (!authInitialized || loading) {
    return (
      <AuthLoadingBoundary>
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
          <div className="text-center">
            <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <p className="text-gray-600 text-lg">Loading...</p>
          </div>
        </div>
      </AuthLoadingBoundary>
    )
  }

  // Handle authentication requirements
  if (requireAuth && !user) {
    console.log('🚫 No user found, redirecting to:', redirectTo)
    return <Navigate to={redirectTo} state={{ from: location }} replace />
  }

  // Handle super admin requirements
  if (requireSuperAdmin && !isSuperAdmin()) {
    console.log('🚫 Super admin required, user is not super admin')
    return <Navigate to="/dashboard" replace />
  }

  // If user is logged in but accessing public routes, redirect to dashboard
  if (!requireAuth && user) {
    console.log('✅ User found but route doesn\'t require auth, redirecting to dashboard')
    return <Navigate to="/dashboard" replace />
  }

  console.log('✅ Route access granted')
  return children
}

export default ProtectedRoute